<template>
    <div class="pill-group">
        <!-- Direct Debit indicator -->
        <span class="pill green" v-if="showDirectDebit && invoice.direct_debit">
            {{ $t('admin.invoices.direct_debit') }}
        </span>

        <!-- Credit note status (this invoice is a credit note) -->
        <span class="pill purple" v-if="invoice.is_credit_note">
            {{ $t(translationPrefix + '.credit_note') }}
        </span>

        <!-- Credited status (this invoice has been credited) -->
        <span class="pill purple" v-else-if="invoice.has_credit_note">
            {{ $t(translationPrefix + '.has_credit_note') }}
        </span>

        <!-- Overdue status -->
        <span class="pill red" v-else-if="invoice.due_date_days_past > 0">
            {{ $tc('admin.invoices.due_days_past', invoice.due_date_days_past) }}
        </span>

        <!-- Paid status -->
        <span class="pill green" v-else-if="invoice.payment_status === 30">
            {{ $t(translationPrefix + '.paid') }}
        </span>

        <!-- Default/Unpaid status -->
        <span class="pill black" v-else-if="showUnpaid">
            {{ paymentLabel(invoice.payment_status) }}
        </span>

        <!-- Reminder count -->
        <span class="pill yellow" v-if="showReminders && invoice.reminder_count">
            {{
                $t('admin.invoices.reminder_count', {
                    count: invoice.reminder_count,
                    at: $i18nDate(new Date(invoice.reminded_at), 'short')
                })
            }}
        </span>
    </div>
</template>

<script>
export default {
    name: 'InvoiceStatusPills',
    props: {
        invoice: {
            type: Object,
            required: true,
        },
        showDirectDebit: {
            type: Boolean,
            default: true,
        },
        showReminders: {
            type: Boolean,
            default: false,
        },
        showUnpaid: {
            type: Boolean,
            default: true,
        },
        translationPrefix: {
            type: String,
            default: 'admin.invoices',
        },
    },
    methods: {
        paymentLabel(status) {
            switch (status) {
                case null:
                    return this.$t('admin.invoices.payment_status_labels.unpaid')
                case 10:
                    return this.$t('admin.invoices.payment_status_labels.pending')
                case 30:
                    return this.$t('admin.invoices.payment_status_labels.paid')
                default:
                    return 'Unknown'
            }
        },
    },
}
</script>
